module.exports = __webpack_public_path__ + "img/xinpin.eacde68e.png";